var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomerRate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 8,
    fill: "#089CFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8555 17.9989L17.8504 12.0039",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.233 13.505C12.8557 13.505 13.3605 13.0002 13.3605 12.3775C13.3605 11.7548 12.8557 11.25 12.233 11.25C11.6103 11.25 11.1055 11.7548 11.1055 12.3775C11.1055 13.0002 11.6103 13.505 12.233 13.505Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2251 18.7491C18.8478 18.7491 19.3526 18.2443 19.3526 17.6216C19.3526 16.9989 18.8478 16.4941 18.2251 16.4941C17.6024 16.4941 17.0977 16.9989 17.0977 17.6216C17.0977 18.2443 17.6024 18.7491 18.2251 18.7491Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9987 24.1673C20.0613 24.1673 24.1654 20.0633 24.1654 15.0007C24.1654 9.93804 20.0613 5.83398 14.9987 5.83398C9.93609 5.83398 5.83203 9.93804 5.83203 15.0007C5.83203 20.0633 9.93609 24.1673 14.9987 24.1673Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerRate);
export default __webpack_public_path__ + "static/media/CustomerRate.ec1ebed855c3b64af2276a34815df7b1.svg";
export { ForwardRef as ReactComponent };